<template>
  <div :id="uuid" :style="{width:width+'px',height:height+'px'}"/>
</template>

<script setup>
import {getDataJson, pollingRefresh,hasNonEmptyValues,hasProperty} from "@/utils/refresh-cpt-data";
import {onMounted, watch, computed} from "vue";
import * as echarts from 'echarts'

const props = defineProps({
  width:Number,
  height:Number,
  option:Object,
  show:Boolean,
  components:Array,
  current: Object
})
// 新增属性兼容旧代码
const attr = props.option.attribute
if (!attr.globalDataReload) attr.globalDataReload = [0]

let dataReload = computed(() => props.option.attribute.globalDataReload || [0])
watch(() => props.current.cptShow,(val)=>{
    if (val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
  watch(() => props.option.attribute.hideCompInTabw,(val)=>{
    if (!val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
watch(() => props.option.attribute, (obj) => {
  processData(props.option.cptDataForm,newData,jsFunFlag)
  loadChart(obj);
},{deep:true})
watch(() => [props.width,props.height], () => {
  chart.resize()
})

let uuid = require('uuid').v1();
let chartOption = {};
let chart = null
let cptData = [];
let newData = "";
let jsFunFlag = false;
const emit = defineEmits(['clickHandler'])

onMounted(()=>{
  chart = echarts.init(document.getElementById(uuid))
  if (dataReload.value.includes(0)) {
    refreshCptData();
  }
})

function refreshCptData(cptDataForm = props.option.cptDataForm,paras) {
  pollingRefresh(uuid, cptDataForm, () => loadData(cptDataForm,paras),
  props.components)
}

function loadData(cptDataForm,paras) {
  getDataJson(cptDataForm,paras,(res)=> {
        // cptData = res;
        newData = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
        jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
        processData(cptDataForm,newData,jsFunFlag)
        loadChart(props.option.attribute);
        loadChart(props.option.attribute);

      })
}
function processData(cptDataForm,res,jsFunFlag){
          // 第一层判断 如果选择数据集
          if(cptDataForm.dataSource == '4') {
            // 第二层判断 ，如果没有配转换脚本
            if(jsFunFlag) { // 没有全部配置映射字段
                if(hasNonEmptyValues(props.option.attribute.cptTableData)) {
                    const dataKey = props.option.attribute.cptTableData;
                     let newarr = [];
                    // 遍历原始数组并重组数据
                      res.forEach(item => {
                      let name = item[dataKey.find(d => d.namekey === 'name').value];
                      let width = item[dataKey.find(d => d.namekey === 'width').value];
                      let height = item[dataKey.find(d => d.namekey === 'height').value];
                      // 创建新的对象并添加到newarr数组中
                      newarr.push({ name, width, height });
                      });
                      console.log(newarr,'新数组')
                      cptData = newarr; 
              }
             } else { // 如果配置了转换脚本
                cptData = res;
             }
          } else { // 不是数据集类型，是静态数据
               cptData = res;
          } 
  }
function loadChart(attribute){
  let attr = JSON.parse(JSON.stringify(attribute))//watch循环修复，xAxis指向的对象被更改影响
  const colorList = attr.colors;

  /*function generateRandomBoxes(numBoxes, minSizeWidth, maxSizeWidth, minSizeHeight, maxSizeHeight) {
    let boxes = [];
    for(let i=0; i<numBoxes; i++) {
      let width = Math.floor(Math.random() * (maxSizeWidth - minSizeWidth + 1)) + minSizeWidth;
      let height = Math.floor(Math.random() * (maxSizeHeight - minSizeHeight + 1)) + minSizeHeight;
      boxes.push({name:'工序'+(i+1),width: width, height: height});
    }
    return boxes;
  }*/

  let originData = cptData;

  let total = 0;
  originData.forEach(item => {
    total += item.height
  })
  const avg = total / originData.length
  const conHeight = Math.round(originData.length / attr.columnNum * avg)

  let outList = []
  let maxHeight = conHeight;
  let currentTop = maxHeight;
  let currentLeft = 0;
  let maxRight = 0;
  let rowData = []
  for(let i=0; i<originData.length; i++) {
    if (currentTop - originData[i].height < 0) {
      currentLeft = maxRight;
      currentTop = maxHeight;
      outList.push(rowData)
      rowData = []
    }
    const item = originData[i]
    const x = currentLeft;
    const y = maxHeight - currentTop
    rowData.push({x:x,y:y,width:item.width,height:item.height,name:item.name})

    if(i===originData.length-1){
      outList.push(rowData)
    }
    currentTop -= originData[i].height;
    maxRight = Math.max(maxRight, currentLeft + originData[i].width);
  }

  let outData = []
  let lastRow = []
  outList.forEach(row => {
    let lastHeight = 0
    let lastLi = {index:0}
    for(let i=0;i<row.length;i++){
      let item = row[i]
      let y = item.height + lastHeight
      item.y = y
      let x = calcX(lastRow, item, lastLi)
      item.x = x
      outData.push([x, y, item.width, item.height, item.name])
      lastHeight += item.height
    }
    lastRow = row
  })

  function calcX(lastRow, item, lastLi) {
    let tempHeight = 0
    let lastMax = 0
    for(let i=lastLi.index;i<lastRow.length;i++){
      const li = lastRow[i]
      if(li.y && i===lastLi.index){
        tempHeight += (li.y - item.y + item.height)
      }else{
        tempHeight += li.height
      }
      if(li.y !== undefined && (item.y - item.height) >= li.y){
        lastMax = 0;
        continue;
      }
      if(li.width+li.x >= lastMax){
        lastMax = li.width
        if(li.x !== undefined){
          lastMax += li.x
        }
      }
      if(tempHeight >= item.height ||  i === lastRow.length-1){
        lastLi.index = i;
        return lastMax
      }
    }
    return 0
  }

  let testData = outData
  const lastItem = lastRow[lastRow.length -1]
  testData.push([lastItem.x + lastItem.width,  0, 0, 0])

  const data = testData.map(function (item, index) {
    return {
      value: item,
      itemStyle: {
        color: colorList[index]
      }
    };
  });
  chartOption = {
    title: attr.title,
    tooltip: attr.tooltip,
    xAxis: attr.xAxis,
    yAxis: attr.yAxis,
    series: [
      {
        type: 'custom',
        renderItem: function (params, api) {
          const start = api.coord([api.value(0), api.value(1)]);
          const width = api.size([api.value(2), api.value(3)]);
          const style = api.style();
          return {
            type: 'rect',
            shape: {
              x: start[0],
              y: start[1],
              width: width[0],
              height: width[1]
            },
            style: style
          };
        },
        label: {
          show: true,
          formatter: '{b}'
        },
        dimensions: ['x','y',attr.label.width, attr.label.height],
        encode: {
          tooltip: [2, 3],
          itemName: 4
        },
        data: data
      }
    ],
    legend: attr.legend,
    dataZoom:attr.dataZoom,
  };
  chart.setOption(chartOption,true);
}

defineExpose({refreshCptData})
</script>

<style scoped>

</style>
